module.exports = __webpack_public_path__ + "static/media/commerce-square.0a06babc.jpg";